module.exports = __webpack_public_path__ + "img/bullit.3a1be091.svg";